import styles from './styles.module.css';
import React, { useState, useContext, useEffect, useCallback } from 'react';
import { AlertMessagesContext } from 'react-alert-messages';
import { ShopContext } from 'Context/ShopContext';
import { MEASURMENT_UNITS } from 'const';
import DataTable from 'components/utils/DataTable/index';
import ShopSettingsService from 'services/ShopSettingsService';
import { ToggleOn, ToggleOff } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

function Units() {
  const { t: tCommon } = useTranslation('common');
  const { postAlertMessage } = useContext(AlertMessagesContext);
  const { shop, setShop } = useContext(ShopContext);
  const [loadingUnitSymbol, setLoadingUnitSymbol] = useState(null);
  const [, setShopUnits] = useState('');
  const [units, setUnits] = useState(null);

  const updateUnits = (symbol) => {
    setLoadingUnitSymbol(symbol);
    let updatedUnits = '';
    setShopUnits((prevShopUnits) => {
      let unitsArray = prevShopUnits?.split(',') || [];

      if (unitsArray.includes(symbol)) {
        unitsArray = unitsArray.filter((item) => item !== symbol);
      } else {
        unitsArray.push(symbol);
      }

      updatedUnits = unitsArray.join(',');

      // Optimistically update the UI list
      updatedMeasurementUnits(updatedUnits);

      updateShopUnitsHandler({ units: updatedUnits });

      return updatedUnits;
    });
  };

  const updateShopUnitsHandler = async (data) => {
    try {
      const resp = await ShopSettingsService.updateShopSettings(data);
      setShop((prevShop) => ({
        ...prevShop,
        ...resp,
      }));
    } catch (error) {
      postAlertMessage({ text: error?.message, type: 'fail' });
      // Rollback on failure
      if (shop?.units) {
        updatedMeasurementUnits(shop.units);
      }
    } finally {
      setLoadingUnitSymbol(null);
    }
  };

  const headerData = [
    {
      label: tCommon('Unit'),
      id: 'unit',
      type: 'text',
    },
    {
      label: tCommon('Symbol'),
      id: 'symbol',
      type: 'text',
    },
    {
      label: tCommon('Status'),
      id: 'status',
      type: 'text',
    },
    {
      label: tCommon('Action'),
      id: 'toggleBtn',
      type: 'callback',
      align: 'left',
      viewRender: (obj) => (
        <span
          onClick={(e) => {
            if (!loadingUnitSymbol) {
              updateUnits(obj.symbol);
            }
            e.stopPropagation();
          }}
          style={{ cursor: loadingUnitSymbol ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center' }}
        >
          {loadingUnitSymbol === obj.symbol ? (
            <CircularProgress size={24} />
          ) : obj.status === tCommon('Active') ? (
            <ToggleOn color="primary" fontSize="large" />
          ) : (
            <ToggleOff color="disabled" fontSize="large" />
          )}
        </span>
      ),
    },
  ];

  const updatedMeasurementUnits = useCallback(
    (updatedUnits) => {
      const statusUpdatedUnits = MEASURMENT_UNITS.map((unit) => ({
        ...unit,
        status: (updatedUnits.split(',') || []).includes(unit.symbol) ? tCommon('Active') : tCommon('Deactive'),
      }));
      setUnits(statusUpdatedUnits);
      setShopUnits(updatedUnits);
    },
    [tCommon]
  );

  const getRowStyle = (row) => {
    if (row.status === tCommon('Active')) {
      return;
    }
    return { backgroundColor: 'rgba(245, 169, 39, 0.2)' };
  };

  useEffect(() => {
    if (!shop) return;
    updatedMeasurementUnits(shop?.units);
  }, [shop, updatedMeasurementUnits]);

  return (
    <div className={styles.contentLayout}>
      <div className={styles.settingsGrid}>
        <div className={styles.BillHeaderDiv}>
          <span className={styles.pageHead}>{tCommon('Manage Units')}</span>
        </div>
        {shop && units && <DataTable columns={headerData} rows={units} rowStyle={getRowStyle} />}
      </div>
    </div>
  );
}

export default Units;
